import React from 'react';

/**
 * Error Boundary — fängt React Render-Crashes ab und zeigt eine
 * freundliche Fehlermeldung statt einem schwarzen/weißen Bildschirm.
 *
 * Verwendung: <ErrorBoundary><App /></ErrorBoundary> in index.js
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', background: '#F5F2ED', color: '#2C2A27', fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          padding: '2rem', textAlign: 'center',
        }}>
          <div style={{ fontSize: '48px', marginBottom: '1rem', opacity: 0.3 }}>🗃️</div>
          <h1 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ fontSize: '0.875rem', color: '#7A7670', marginBottom: '1.5rem', maxWidth: '400px', lineHeight: 1.6 }}>
            Ein unerwarteter Fehler ist aufgetreten. Deine Daten sind sicher — sie liegen als Dateien auf deiner Festplatte.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 20px', border: 'none', borderRadius: '8px',
              background: '#D9455F', color: '#fff', fontSize: '0.875rem',
              fontWeight: 500, cursor: 'pointer',
            }}
          >
            App neu laden
          </button>
          {this.state.error && (
            <details style={{ marginTop: '2rem', fontSize: '0.75rem', color: '#A09A93', maxWidth: '500px', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer' }}>Technische Details</summary>
              <pre style={{ marginTop: '0.5rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
